/* eslint-disable react/no-danger */
import React, { useEffect, useState, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import PT from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { isEmpty, values, get, findIndex, omit } from 'lodash';

import { Responsive } from 'common/components';
import { SliderComponent, Footer, AudioPlayer } from 'client/components/common';
import { dataLayerEvents, fileLink, bgImage } from 'common/utils';
import { PODCAST_ROOT_ROUTE, MAIL_TO_ANALYTICS } from 'client/constants';

import * as css from './Podcast.scss';

const Podcast = props => {
	const data = values(get(props, 'items', {}));
	const id = props.match.params.podcastsId;
	const infoSection = useRef();
	const audioPlayer = useRef();
	const footerRef = useRef();
	const stikyBtnRef = useRef();
	const podcast = props.items[id];
	const infoText = get(podcast, 'content.text', '');
	const [stateId, setStateId] = useState([]);
	const [animationState, setAnimationState] = useState('');
	const [fixed, setFixed] = useState(false);
	const [topPosition, setTopPosition] = useState();
	const title = get(podcast, 'name', '');
	const subTitle = get(podcast, 'subtitle', '');
	const btnReadText = 'לקריאה';
	const btnListenText = 'להאזנה';
	const mailToText = 'לחצו לשליחת קורות חיים';
	const isDesktop = Responsive.isMatching(Responsive.DESKTOP);
	const podcastBgImage = fileLink(get(podcast, `${isDesktop ? 'image' : 'mobileImg'}`));
	let timeout = null;
	let timeout2 = null;

	const nextPrevPodcast = index => {
		let indexPrev = null;
		let indexNext = null;
		if (!isEmpty(data[index - 1])) {
			indexPrev = data[index - 1];
		} else {
			indexPrev = data[data.length - 1];
		}
		if (!isEmpty(data[index + 1])) {
			indexNext = data[index + 1];
		} else {
			indexNext = data[data.length + 1];
		}
		return [indexPrev, indexNext];
	};

	useEffect(() => {
		if (Responsive.isMatching(Responsive.DESKTOP)) {
			window.scrollTo({
				top: 0,
				behavior: 'instant',
			});
		}

		document.addEventListener('scroll', onScroll);

		return () => {
			document.removeEventListener('scroll', onScroll);
			clearTimeout(timeout);
			clearTimeout(timeout2);
		};
	}, []);

	useEffect(() => {
		if (!isEmpty(props.items)) {
			dataLayerEvents.pageView(window.location.href, title);

			setStateId(nextPrevPodcast(findIndex(data, item => item.id === id)));
		}
	}, [props.items]);

	const onScroll = () => {
		const infoSectionPosition = infoSection.current.offsetTop;
		const stikyBtnHeight = stikyBtnRef.current.clientHeight;
		const footerPosition = footerRef.current.offsetTop;
		const btnPosAtStart = infoSectionPosition + 50;
		const scrollHeight = btnPosAtStart / 2;
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (Responsive.isMatching(Responsive.DESKTOP)) {
			if (window.pageYOffset >= scrollHeight) {
				setFixed(true);
				setTopPosition(scrollHeight);
			} else if (window.pageYOffset <= scrollHeight) {
				setFixed(false);
				setTopPosition(btnPosAtStart);
			}
		} else {
			const mobilePos = window.innerHeight + scrollTop - stikyBtnHeight - 10;
			if (window.pageYOffset >= 0 && window.pageYOffset + window.innerHeight - stikyBtnHeight <= footerPosition) {
				setFixed(true);
				setTopPosition(mobilePos);
			} else {
				setFixed(false);
				setTopPosition(0);
			}
		}
	};

	const onBtnListenClick = () => {
		audioPlayer.current.onPlayClick();
	};

	const animate = (node, done) => {
		if (props.in) {
			setAnimationState('in');
			setTimeout(done, parseInt(css.animationInTime, 10));

			if (!Responsive.isMatching(Responsive.DESKTOP)) {
				document.querySelector(`.${css.podcast}`).style.position = 'fixed';
				document.body.style.position = 'absolute';
				document.body.style.overflow = 'hidden';

				timeout2 = setTimeout(() => {
					document.body.style.overflow = 'scroll';
					document.querySelector(`.${css.podcast}`).style.position = 'absolute';
				}, 1500);
			}
		} else {
			setAnimationState('out');
			setTimeout(done, parseInt(css.animationOutTime, 10));
		}
	};

	const scrollToInfo = () => {
		infoSection.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
	};

	const onStikyBtnClick = () => {
		dataLayerEvents.onCVBtnClick(MAIL_TO_ANALYTICS.ASIDE_STICKY);

		window.open('mailto:podcast@jobs.rafael.co.il', '_blank');

		// if (Responsive.isMatching(Responsive.DESKTOP)) {
		// 	footerRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
		// } else {
		// 	const footerPosition = footerRef.current.offsetTop + window.innerHeight;

		// 	window.scrollTo({
		// 		top: footerPosition,
		// 		behavior: 'smooth',
		// 	});
		// }
	};

	const onCloseInfoSection = () => {
		timeout = setTimeout(() => {
			props.history.push(`/`);
		}, 10);
	};

	const cssTProps = omit(props, [
		'className',
		'isStarted',
		'staticContext',
		'history',
		'match',
		'items',
		'location',
		'categories',
		'settings',
		'inAnimFreeze',
	]);

	return (
		<CSSTransition {...cssTProps} addEndListener={animate}>
			<div>
				<div
					className={classNames(css.podcast, props.isStarted && css[animationState], {
						[css.inAnimFreeze]: props.inAnimFreeze,
					})}
				>
					<section className={css.sectionAudio} style={bgImage(podcastBgImage)}>
						<div className={css.mainAudio}>
							<AudioPlayer
								podcastName={title}
								audioSrc={fileLink(get(podcast, 'audio'))}
								ref={audioPlayer}
							/>
						</div>
						<div className={css.wrapBtn}>
							<Responsive query={Responsive.DESKTOP}>
								<button
									type="button"
									className={classNames(css.btnPodcast, css.btn, css.btnBlue)}
									onClick={scrollToInfo}
								>
									<p>{btnReadText}</p>
									<i className={css.iconRead} />
								</button>
							</Responsive>
							<button
								type="button"
								className={classNames(css.btn, css.btnWhite)}
								onClick={onBtnListenClick}
							>
								<p>{btnListenText}</p>
								<i className={css.iconEar} />
							</button>
						</div>
					</section>
					<section id="info-section" className={css.sectionInfo} ref={infoSection}>
						<Responsive query={Responsive.MOBILE || Responsive.TABLET}>
							<button type="button" className={css.closeInfoSection} onClick={onCloseInfoSection} />
						</Responsive>
						<div className={css.wrapCenter}>
							<div className={css.title}>
								<p>{title}</p>
								<span>{subTitle}</span>
							</div>
							<div className={css.text} dangerouslySetInnerHTML={{ __html: infoText }} />
							<Responsive query={Responsive.DESKTOP}>
								<div className={css.nextPodcast}>
									<Link
										to={`${PODCAST_ROOT_ROUTE}/${get(stateId[0], 'id', '')}`}
										className={css.nextButton}
									>
										הקודם
									</Link>
									<Link
										to={`${PODCAST_ROOT_ROUTE}/${get(stateId[1], 'id', '')}`}
										className={css.prevButton}
									>
										הבא
									</Link>
								</div>
							</Responsive>
						</div>
					</section>
					<SliderComponent items={data} isPodcast currentItemId={id} />
					<div ref={footerRef}>
						<Footer className={css.footer} />
					</div>
				</div>
				<div
					className={classNames(css.stikyBtn, { [css.stikyBtnActive]: fixed })}
					style={{ top: `${topPosition}px` }}
					ref={stikyBtnRef}
					onClick={onStikyBtnClick}
				>
					<div className={css.stikyBtnInner}>
						<i className={css.iconClip} />
						<p>{mailToText}</p>
					</div>
				</div>
			</div>
		</CSSTransition>
	);
};

Podcast.propTypes = {
	items: PT.shape({}).isRequired,
	match: PT.shape({
		params: PT.shape({
			podcastsId: PT.string,
		}),
	}).isRequired,
	isStarted: PT.bool.isRequired,
	in: PT.bool.isRequired,
	history: PT.shape({
		push: PT.func,
	}).isRequired,
	inAnimFreeze: PT.bool.isRequired,
};

export default Podcast;
